import { getPrivilegeLabel } from "../../Constants";

import Selector from "./Selector";

export const privilegeTypes = [
  { title: "Plant", value: -1 },
  { title: "None", value: 0 },
  { title: "Public", value: 1 },
  { title: "AMI", value: 2 },
  { title: "Management", value: 3 },
  { title: "Admin", value: 4 },
  { title: "AMI&Admin", value: 5 },
];

export default function PrivilegeSelector({ value, language, onChange }) {
  return (
    <Selector
      options={privilegeTypes}
      value={value}
      onChange={onChange}
      className="privilege"
      getOptionLabel={(option) => getPrivilegeLabel(option.title, language)}
    />
  );
}
